/**
 * Daily-reset countdown — CLIENT-ONLY, ZERO wire. Pure time math (no DOM, no storage) so it unit-tests
 * under node.
 *
 * The server rolls a captain's daily allowances on the UTC CALENDAR DAY: `room.ts` keys the day off
 * `new Date(nowMs).toISOString().slice(0,10)` (and `economy.ts` does the same for the mint ledger), so the
 * next reset — dailyEarned back to 0, the daily-login bonus, steal caps — is always the next 00:00 UTC.
 * These helpers derive "resets in 7h 32m" from the wall clock alone, no new snapshot field.
 */

/** Milliseconds from `nowMs` until the next 00:00 UTC (the server's daily roll boundary). */
export function msUntilUtcMidnight(nowMs: number = Date.now()): number {
  const d = new Date(nowMs);
  const next = Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate() + 1, 0, 0, 0, 0);
  return Math.max(0, next - nowMs);
}

/** Compact human span for a countdown: "7h 32m", "12m" under the hour, "<1m" in the last minute. */
export function fmtResetIn(ms: number): string {
  const totalMin = Math.floor(ms / 60000);
  const h = Math.floor(totalMin / 60);
  const m = totalMin % 60;
  if (h > 0) return `${h}h ${m}m`;
  if (m > 0) return `${m}m`;
  return '<1m';
}

/** One-call label the HUD/panel shows next to the daily cap: "resets in 7h 32m". */
export function dailyResetLabel(nowMs: number = Date.now()): string {
  return `resets in ${fmtResetIn(msUntilUtcMidnight(nowMs))}`;
}
